import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Bot, RefreshCw, AlertTriangle } from "lucide-react";
import { adminSettlementStatus, adminRunSettlement, apiError } from "@/lib/adminApi";

export function AutoSettlePanel() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["settlement-status"], queryFn: adminSettlementStatus, refetchInterval: 60_000 });
  const run = useMutation({
    mutationFn: adminRunSettlement,
    onSuccess: (r) => { qc.invalidateQueries(); toast.success(`Auto-settlement ran: ${r.settled} settled · ${r.pending} still live · ${r.manual_review} need review`); },
    onError: (e) => toast.error(apiError(e)),
  });
  const last = data?.last_run;
  const review = data?.needs_attention || [];
  return (
    <div className="mb-6 rounded-lg border border-[#1E2738] bg-[#0F131D] p-4" data-testid="auto-settle-panel">
      <div className="flex flex-wrap items-center gap-3">
        <Bot size={15} className="text-[#00E676]" />
        <span className="font-display text-xs font-bold uppercase tracking-wider text-white">Automatic settlement</span>
        <span className="font-mono text-[11px] text-slate-400" data-testid="auto-settle-last-run">
          runs every 15 min · last run {last?.at ? new Date(last.at).toLocaleString() : "—"}{last ? ` · checked ${last.checked}, settled ${last.settled}, live ${last.pending}, review ${last.manual_review}, retry ${last.retry}` : ""}
        </span>
        <button data-testid="auto-settle-run-now" disabled={run.isPending} onClick={() => run.mutate()} className="ml-auto flex items-center gap-1 rounded-md border border-[#2A364F] px-3 py-1.5 font-mono text-[11px] uppercase text-slate-300 hover:border-[#00E676]/50 hover:text-[#00E676]">
          <RefreshCw size={12} className={run.isPending ? "animate-spin" : ""} /> Run now
        </button>
      </div>
      {review.length > 0 && (
        <ul className="mt-3 space-y-1" data-testid="auto-settle-review-list">
          {review.map((p) => (
            <li key={p.id} className="flex flex-wrap items-center gap-2 rounded-md border border-[#F59E0B]/30 bg-[#F59E0B]/5 px-3 py-1.5 font-mono text-[11px] text-[#F59E0B]" data-testid={`auto-settle-review-${p.id}`}>
              <AlertTriangle size={12} /> <span className="text-white">{p.player ? `${p.player} ` : ""}{p.selection}</span> · {p.game} — {p.auto_settle?.reason} <span className="text-slate-500">(settle manually below)</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
